import React, {useState} from 'react';
import PropTypes from 'prop-types';
import {Alert, Card, CardBody, CardHeader, Col, Modal, ModalBody, ModalFooter, ModalHeader, Row} from "reactstrap";
import {Accordion, AccordionCollapse, AccordionToggle} from "react-bootstrap";
import apiPlatform from "../../apiPlatform";
import useAfterUpdateEffect from "../../utils/useAfterUpdateEffect";
import {vehicleDamagesTypesByCarType} from "../../utils/Vehicle/vehicleDamagesTypesByCarType";
import {vehicleDamagesImagePatternByType} from "../../utils/Vehicle/vehicleDamagesImagePatternByType";
import classnames from "classnames";
import {first} from "lodash";
import Button from "../Button";
import getWorkshopSetting from "../../utils/getWorkshopSetting";
import {useTranslation} from "react-i18next";

const VehicleDamagePatternImageTypeChoose = props => {
  const { t } = useTranslation('vehicle_damage_pattern_image_type');
  const [modalOpen, setModalOpen] = useState(false)
  const toggleModal = () => setModalOpen(!modalOpen)
  const [carTypes, setCarTypes] = React.useState([]);

  useAfterUpdateEffect(() => {
    if(modalOpen){
      apiPlatform.carTypes.list()
        .then(({data}) => setCarTypes(data['hydra:member'].filter(carType => getWorkshopSetting('vehicle.carTypes').includes(carType.id))))
    }
  }, [modalOpen])

  const onChoose = (vehiclePatternType) => {
    props.onChoose(vehiclePatternType)
    setModalOpen(false)
  }

  return <React.Fragment>
    <Button tooltip={t('btn_tooltip')} color={'light'} size={'sm'} onClick={e => {
      e.preventDefault()
      toggleModal()
    }}>{props.btnText ?? t('btn_text')}</Button>
    {modalOpen && <Modal isOpen size={'xl'} scrollable toggle={toggleModal}>
      <ModalHeader toggle={toggleModal}>{t('modal_header')}</ModalHeader>
      <ModalBody>
        {carTypes.length > 0 && <Accordion defaultActiveKey={(props?.carType ?? first(carTypes)?.id)?.toString()}>
          {carTypes.map(carType => <Card className="mb-0">
            <CardHeader className="p-0">
              <AccordionToggle className="py-2 px-3 cursor-pointer" eventKey={carType.id.toString()} as={'div'}>{carType.name}</AccordionToggle>
            </CardHeader>
            <AccordionCollapse eventKey={carType.id.toString()}>
              <CardBody className="p-3">
                {
                  vehicleDamagesTypesByCarType(carType.id)?.length > 0
                    ? <Row className="mx-0">
                      {vehicleDamagesTypesByCarType(carType.id)?.map(vehiclePatternType => <Col xs={6} sm={6} md={4} className="p-2">
                        <img src={vehicleDamagesImagePatternByType(vehiclePatternType)} className={classnames({
                          'w-100 border cursor-pointer': true,
                          'border-primary': props.selected === vehiclePatternType,
                          'border-light': props.selected !== vehiclePatternType,
                        })} onClick={() => onChoose(vehiclePatternType)}/>
                      </Col>)}
                    </Row>
                    : <Alert className="mb-0" color={'warning'}>{t('no_templates_alert')}</Alert>
                }
              </CardBody>
            </AccordionCollapse>
          </Card>)}
        </Accordion>}
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" onClick={toggleModal}>{t('common:btn.cancel')}</Button>
      </ModalFooter>
    </Modal>}
  </React.Fragment>
};

VehicleDamagePatternImageTypeChoose.propTypes = {
  selected: PropTypes.string,
  btnText: PropTypes.any,
  onChoose: PropTypes.func.isRequired,
};

export default VehicleDamagePatternImageTypeChoose;